export interface FolderGroup {
  folderName: string;
  files: File[];
}

/**
 * Groups files by their root folder name based on webkitRelativePath
 * @param files Array of files with webkitRelativePath property
 * @returns Array of folder groups, each containing folder name and its files
 */
export const groupFilesByRootFolder = (files: File[]): FolderGroup[] => {
  const folderMap = new Map<string, File[]>();

  for (const file of files) {
    let folderName = "New Folder"; // Default fallback

    if (file.webkitRelativePath) {
      // Extract the root folder name from the relative path
      const pathParts = file.webkitRelativePath.split("/");
      folderName = pathParts[0];
    }

    // Group files by folder name
    if (!folderMap.has(folderName)) {
      folderMap.set(folderName, []);
    }
    folderMap.get(folderName)!.push(file);
  }

  // Convert map to array of folder groups
  return Array.from(folderMap.entries()).map(([folderName, files]) => ({
    folderName,
    files,
  }));
};
